module.exports = __webpack_public_path__ + "img/nip.1ebcec35.png";